import React from 'react';
import { ScreenRedirect } from '@atlassian/jira-screen-redirect/src/ui/ScreenRedirect.tsx';
import { createRouterSelector } from '@atlassian/react-resource-router';

const useMatchUrl = createRouterSelector((state) => state.match.url);

export const ListRedirect = () => {
	const matchUrl = useMatchUrl();

	return <ScreenRedirect to={matchUrl.replace('issues', 'list')} />;
};
